import { createContext, useContext } from 'react';
export const AnalyticsContext = createContext(null);
export function useAnalytics() {
    return useContext(AnalyticsContext);
}
//# sourceMappingURL=use-analytics.js.map